export default __webpack_public_path__ + "static/media/1.811b20dc.jpg";